export const PRODUCTS_REQUEST = 'permissions/PRODUCTS_REQUEST';
export const PRODUCTS_SUCCESS = 'permissions/PRODUCTS_SUCCESS';
export const PRODUCTS_FAILURE = 'permissions/PRODUCTS_FAILURE';
